import { render, staticRenderFns } from "./AcademicPosition.vue?vue&type=template&id=5ef586b1&scoped=true"
import script from "./AcademicPosition.vue?vue&type=script&lang=js"
export * from "./AcademicPosition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef586b1",
  null
  
)

export default component.exports